import { Search } from "lucide-react";
import { Switch } from "@/components/ui/switch";
import { ADMIN_STATUSES } from "./StatusBadge";

const SORTS = [["created_at", "Sign-up date"], ["company_name", "Company"], ["leads", "Leads"], ["last_login_at", "Last login"], ["trial_ends_at", "Trial end"], ["status", "Status"]];
const selectCls = "h-10 rounded-lg border bg-card px-2.5 text-sm text-foreground focus:outline-none focus:ring-2 focus:ring-[color:var(--brand)]";

export const AccountFilters = ({ f, set }) => (
  <div className="flex flex-col gap-2.5 sm:flex-row sm:flex-wrap sm:items-center" data-testid="admin-filters">
    <label className="relative flex-1 sm:min-w-[220px]">
      <Search className="pointer-events-none absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-muted-foreground" />
      <input value={f.q} onChange={(e) => set({ q: e.target.value })} placeholder="Search company or email" data-testid="admin-search-input"
        className="h-10 w-full rounded-lg border bg-card pl-9 pr-3 text-sm text-foreground focus:outline-none focus:ring-2 focus:ring-[color:var(--brand)]" />
    </label>
    <div className="grid grid-cols-2 gap-2.5 sm:flex">
      <select value={f.status} onChange={(e) => set({ status: e.target.value })} className={selectCls} data-testid="admin-status-filter">
        <option value="">All statuses</option>
        {Object.entries(ADMIN_STATUSES).map(([k, { label }]) => <option key={k} value={k}>{label}</option>)}
        <option value="suspended">Suspended</option>
        <option value="double_billing">Comped + paying</option>
      </select>
      <select value={`${f.sort}:${f.order}`} onChange={(e) => { const [sort, order] = e.target.value.split(":"); set({ sort, order }); }} className={selectCls} data-testid="admin-sort-select">
        {SORTS.flatMap(([k, label]) => [["desc", "↓"], ["asc", "↑"]].map(([o, arrow]) => <option key={`${k}:${o}`} value={`${k}:${o}`}>{label} {arrow}</option>))}
      </select>
    </div>
    <label className="flex items-center gap-2 text-sm text-muted-foreground">
      <Switch checked={f.include_tests} onCheckedChange={(v) => set({ include_tests: v })} data-testid="admin-include-tests-toggle" />
      Include test accounts
    </label>
  </div>
);
